export const isElectron = () =>
  typeof window !== "undefined" && !!window.process?.versions?.electron;

export const getIpcRenderer = () => {
  if (!isElectron()) return null;
  return window.require("electron").ipcRenderer;
};
